/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ChangeTicketWorkflowStatusDto } from '../../models/change-ticket-workflow-status-dto';
import { TicketItem } from '../../models/ticket-item';

export interface TicketControllerChangeTicketStatus$Params {
  id: number;
      body: ChangeTicketWorkflowStatusDto
}

export function ticketControllerChangeTicketStatus(http: HttpClient, rootUrl: string, params: TicketControllerChangeTicketStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerChangeTicketStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketItem;
      }>;
    })
  );
}

ticketControllerChangeTicketStatus.PATH = '/ticket/change-ticket-status/{id}';
